import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useHistory, useLocation } from "react-router-dom";
import { CATEGORY_WITH_COURSES_QUERY } from "../../queries/queries";
import Error from "../error";
import Loading from "../loading";
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import backArrow from '../../assets/images/left_arrow.png';

const CategoryCourses = () => {
  const location = useLocation();
  const categoryId = location.state?.categoryId;

  const { loading, error, data } = useQuery(CATEGORY_WITH_COURSES_QUERY, {
    variables: { categoryId },
    fetchPolicy: "no-cache",
  });

  useMakeScrollable()
  let history = useHistory();

  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const categoryWithCourses = data?.categoryWithCourses || [];

  const handleBack = () => {
    history.goBack() 
  };

  return (
    <div className="scrollable">
      <div className="category-page">
                <img 
                  src={backArrow} 
                  alt="back" 
                  className="points-header-arrow" 
                  onClick={handleBack} 
                />
      {categoryWithCourses.imageUrl 
        && <img 
              src={categoryWithCourses.imageUrl} 
              alt="Category logo" 
              className="category-image"
      />}
      {categoryWithCourses.description 
        && <div className='category-description'>{categoryWithCourses.description}</div>
      }
      <div key={`${categoryWithCourses.id}-${categoryWithCourses.name}`} className="category-section">
      <div className="new-courses-top">
        <div className='category-name'>{categoryWithCourses.name}</div>
      </div>
      <div className="courses-row">
        {categoryWithCourses.courses.map(course => (
          <div 
            className="course-item-container" 
            key={course.id}
            onClick={(e) => {
              e.preventDefault();
              history.push(`/course_details/${course.id}`);
            }}
          >
            <img className="course-item" src={course.previewUrl} />
            <div 
              className="course-item-title"
              dangerouslySetInnerHTML={{ __html: course.nameShort }}
            ></div>
          </div>
        ))}
      </div>
    </div>
      </div>
    </div>
  );
};

export default CategoryCourses;
